import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "antd";
import React from "react";
import GlobalConstants from "../../../swzutils/GlobalConstants";
import { faMap } from "@fortawesome/free-solid-svg-icons/faMap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const MapShareVicButton = () => {
    return (_jsx(Button, { target: GlobalConstants.MAP_SHARE_VIC_TARGET_NAME, href: "https://mapshare.vic.gov.au/mapsharevic", icon: _jsx(FontAwesomeIcon, { icon: faMap }), children: "Open Mapshare VIC" }));
};
export default MapShareVicButton;
